import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';
import { Link } from 'react-router-dom';

export const Wrapper = styled.header``;

export const Inside = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${setRem(130)};
  padding: 0 ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
`;

export const Title = styled(Link)`
  font-size: ${setRem(24)};
  line-height: 1.01;
  letter-spacing: -2px;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 700;
  color: ${setColor.primaryColor};

  & span {
    color: ${setColor.secondaryColor};
  }
`;

export const Logo = styled(Link)`
  display: block;

  & img {
    display: block;
    height: ${setRem(78)};
    width: auto;
  }
`;

export const TimeWrapper = styled.div``;

export const Time = styled.span`
  display: block;
  text-align: right;
  color: ${setColor.primaryColor};

  &:first-of-type {
    font-weight: 700;
  }
`;
